// utils/formHelpers.js
export const getChangedFields = (originalData, formValues) => {
  if (!originalData) return formValues; // If no original data, send all values

  const changes = {};

  // Get all keys from both originalData and formValues
  const allKeys = new Set([
    ...Object.keys(originalData),
    ...Object.keys(formValues),
  ]);

  allKeys.forEach((key) => {
    const formValue = formValues[key];
    const originalValue = originalData[key];

    // Check if field exists in formValues
    const existsInForm = key in formValues;
    const existsInOriginal = key in originalData;

    // Check if values are "empty"
    const isFormValueEmpty =
      formValue === null || formValue === undefined || formValue === "";

    const isOriginalValueEmpty =
      originalValue === null ||
      originalValue === undefined ||
      originalValue === "";

    // If field exists in original but NOT in form
    if (existsInOriginal && !existsInForm) {
      // Only send null if original had a real value (not null/undefined/"")
      if (!isOriginalValueEmpty) {
        changes[key] = null;
      }
      return;
    }

    // If field doesn't exist in original, skip (it's a new form-only field like Password)
    if (!existsInOriginal) {
      return;
    }

    // If both are empty, skip this field
    if (isFormValueEmpty && isOriginalValueEmpty) {
      return;
    }

    // If form value is empty but original had a value, send null to clear it
    if (isFormValueEmpty && !isOriginalValueEmpty) {
      changes[key] = null;
      return;
    }

    // Convert to string for comparison if both exist
    const normalizedFormValue =
      formValue !== null && formValue !== undefined && formValue !== ""
        ? String(formValue).trim()
        : formValue;
    const normalizedOriginalValue =
      originalValue !== null &&
      originalValue !== undefined &&
      originalValue !== ""
        ? String(originalValue).trim()
        : originalValue;

    // Only include if values are different
    if (normalizedFormValue !== normalizedOriginalValue) {
      changes[key] = formValue;
    }
  });

  return changes;
};
